// InvoiceReducer.js — Manufacturer Module, Phase 6, Batch 2.
// Backs Invoice screens only. Wired into rootReducer.js as `invoice`.

const initialState = {
  invoices: [],
  selectedInvoice: null,
  loading: false,
  actionLoading: false,
  confirmLoading: false,
  error: null
};

const InvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_INVOICES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_INVOICES_SUCCESS':
      return { ...state, loading: false, invoices: action.payload, error: null };
    case 'FETCH_INVOICES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GET_INVOICE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_INVOICE_SUCCESS':
      return { ...state, actionLoading: false, selectedInvoice: action.payload, error: null };
    case 'GET_INVOICE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CREATE_INVOICE_REQUEST':
    case 'CANCEL_INVOICE_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_INVOICE_SUCCESS':
      return { ...state, actionLoading: false };

    case 'CONFIRM_INVOICE_REQUEST':
      return { ...state, confirmLoading: true, error: null };

    case 'CONFIRM_INVOICE_SUCCESS':
      return {
        ...state,
        confirmLoading: false,
        invoices: state.invoices.map((inv) =>
          inv.id === action.payload.id ? { ...inv, status: 'confirmed' } : inv
        ),
        selectedInvoice:
          state.selectedInvoice && state.selectedInvoice.id === action.payload.id
            ? { ...state.selectedInvoice, status: 'confirmed' }
            : state.selectedInvoice
      };

    case 'CANCEL_INVOICE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        invoices: state.invoices.map((inv) =>
          inv.id === action.payload.id ? { ...inv, status: 'cancelled' } : inv
        ),
        selectedInvoice:
          state.selectedInvoice && state.selectedInvoice.id === action.payload.id
            ? { ...state.selectedInvoice, status: 'cancelled' }
            : state.selectedInvoice
      };

    case 'CREATE_INVOICE_FAILURE':
    case 'CANCEL_INVOICE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CONFIRM_INVOICE_FAILURE':
      return { ...state, confirmLoading: false, error: action.payload };

    case 'CLEAR_SELECTED_INVOICE':
      return { ...state, selectedInvoice: null };

    default:
      return state;
  }
};

export default InvoiceReducer;